<div class="form-translations-modal__container common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'form-translations-modal.title'">
      _Traducciones del formulario
    </span>
  </div>
  <div class="common-modal__content">
    @if (formTranslations.conceptInfo.hasInstances && formTranslations.showWarning) {
      <div class="common-status-message__g-container-warning">
        <i class="lf-icon-warning-full common-status-message__icon-md">
        </i>
        <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span
                afTranslate="form-translations-modal.evaluated-concept"
                class="common-status-message__g-subtitle">
                _El concepto ya ha sido evaluado. No podrás modificar las traducciones de elementos en uso, solamente añadir traducciones nuevas.
              </span>
            </div>
            <button
              (click)="formTranslations.showWarning = false;"
              class="common-button__icon-xs-noborder">
              <i class="lf-icon-close-thick common-icon__sm">
              </i>
            </button>
          </div>
        </div>
      </div>
    }
    <div class="form-translations-modal__translations-header">
      <ul class="common-tab__tertiary-list-block">
        @for (selectedLanguage of formTranslations.formTranslationsLanguagesSelected; track selectedLanguage.listValueId) {
          <li>
            <button
              [ngClass]="{
                'common-tab__tertiary--selected': selectedLanguage.active
              }"
              (click)="changeActiveLanguagesSelected(selectedLanguage)"
              class="common-tab__tertiary">
              <p class="common-tab__tertiary-button-text"
                [ngClass]="{'common-tab__tertiary-button-text--error': selectedLanguage.error}">
                @if (formTranslations.formTranslationsLanguagesSelected.length > 5){
                  {{selectedLanguage.appLanguage.substring(0, 2).toUpperCase()}}
                }
                @else {
                  {{selectedLanguage.text}}
                }
              </p>
              @if (!selectedLanguage.defaultOption) {
                <button
                  (click)="removeActiveLanguage(selectedLanguage)"
                  class="common-button__icon-xs-noborder">
                  <i class="lf-icon-close-thick common-icon__sm common-icon__neutral">
                  </i>
                </button>
              }
            </button>
          </li>
        }
        @if (formTranslations.formTranslationsLanguagesApp.length !== formTranslations.formTranslationsLanguagesSelected.length) {
          <li #selectLanguagesContainer>
            <button
              (click)="selectLanguagesDropdown.toggle($event, selectLanguagesContainer)"
              class="common-tab__tertiary"
              [ngClass]="{
                'common-tab__tertiary--active': openLanguagesDropdown
                }">
              <p [afTranslate]="'protection-data-modal.add-translation'"
                class="common-tab__tertiary-button-text">
                _Añadir traducción
              </p>
              <i class="lf-icon-translate common-icon__md"></i>
            </button>
            <p-overlayPanel
              #selectLanguagesDropdown
              (onShow)="openLanguagesDropdown = true"
              (onHide)="openLanguagesDropdown = false"
              styleClass="common-dropdown-overlay__container">
              <ng-template pTemplate="content">
                <div class="common-dropdown__items-container">
                  @for (language of formTranslations.formTranslationsLanguagesApp; track language.listValueId) {
                    @if (notSelectLanguage(language)) {
                      <button
                        (click)="selectLanguage(language, selectLanguagesDropdown)"
                        class="common-dropdown-list__si-button">
                        <span-tooltip
                          class="common-dropdown-list__si-text-container"
                          [text]="language.text"
                          [tooltipPosition]="'top'">
                        </span-tooltip>
                      </button>
                    }
                  }
                </div>
              </ng-template>
            </p-overlayPanel>
          </li>
        }
      </ul>
    </div>
    <div class="form-translations-modal__fields-container">
      <div class="form-configuration-modal__group-container">
        <div class="customize-concept__group-container-title">
          <div class="common-section-title__param-container">
            <div class="common-section-title__param-inner-container">
              <div class="common-section-title__param-band">
                <div class="common-section-title__param-title-band-container">
                  <div [ngClass]="{
                    'common-section-title__param-label-icons-container': !formTranslations.fieldContainer.editableName,
                    'common-section-title__param-input-icons-group': formTranslations.fieldContainer.editableName && !formTranslations.fieldContainer.error,
                    'common-section-title__param-input-icons-container-error': formTranslations.fieldContainer.error
                    }">
                    @if (formTranslations.fieldContainer.editableName) {
                      <input
                        #groupFormInput
                        type="text"
                        class="common-section-title__param-input-group"
                        [(ngModel)]="formTranslations.fieldContainer.name"
                        [disabled]="formTranslations.disabledGroup"
                        maxlength="300"
                        (blur)="fieldContainerNameChange(formTranslations.fieldContainer)"
                      />
                    }
                    @else {
                      <span-tooltip
                        class="common-section-title__param-label-band"
                        [text]="formTranslations.fieldContainer.name">
                      </span-tooltip>
                    }
                  </div>
                </div>
                @if (!formTranslations.disabledGroup && formTranslations.typeView !== 'translationsViewNoEditable') {
                  @if (formTranslations.fieldContainer.editableName) {
                    <button
                      class="common-button__icon-md-noborder"
                      (click)="fieldContainerNameChange(formTranslations.fieldContainer)"
                      [disabled]="!formTranslations.fieldContainer.name">
                      <i class="lf-icon-check common-icon__md">
                      </i>
                    </button>
                  }
                  @else {
                    <button class="common-button__icon-md-noborder"
                      (click)="formTranslations.fieldContainer.editableName = true">
                      <i class="lf-icon-editable-form common-icon__md">
                      </i>
                    </button>
                  }
                }
              </div>
            </div>
            @if (formTranslations.fieldContainer.error) {
              <div class="common-section-title__param-error-container">
                <span [afTranslate]="'common.field-mandatory'">
                  _Campo obligatorio
                </span>
              </div>
            }
          </div>
        </div>
        <div class="form-configuration-modal__fields-container">
          @for (containerField of formTranslations.fieldContainer.fields; track $index) {
            <div
              class="customize-concept__field-item">
              <customize-fields
                [field]="containerField"
                [previewMode]="formTranslations.previewMode"
                [typeView]="formTranslations.typeView"
                [fieldContainer]="formTranslations.fieldContainer"
                [concept]="formTranslations.conceptInfo"
                [disabledFormTranslations]="containerField.disabledTranslations"
                (launchAction)="launchAction($event)">
              </customize-fields>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="common-modal__footer">
    <button
      class="common-button__text-border"
      (click)="handleDismiss()">
      <span
        class="common-button__text-title"
        [afTranslate]="'common.cancel'">
        _Cancelar
      </span>
    </button>
    <button
      class="common-button__text"
      (click)="handleAccept()">
      <span
        class="common-button__text-title"
        [afTranslate]="'common.save'">
        _Guardar
      </span>
    </button>
  </div>
</div>

